import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Typography,
  Select,
  MenuItem,
  TextField,
  Checkbox,
  FormControlLabel,
  Chip,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";
import socket from "../../../socket/socket";

function BulkExamLogout() {
  const classes = useStyles();

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();
  const [selectedLearner, setSelectedLearner] = useState([]);
  const [selectedLearnerId, setSelectedLearnerId] = useState([]);
  const [learners, setLearners] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleClose = () => {
    navigate("/admin/dashboard");
  };

  const [center, setCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");

  const [cources, setCources] = useState([]);
  const [selectedCource, setSelectedCource] = useState("");

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

 useEffect(()=>{
    socket.connect();
    return ()=>{
      socket.disconnect();
    }
  },[])

  const fetchCenter = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/filter/all`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCenter(data.centers);
      } else {
        console.error("Failed to fetch center data");
      }
    } catch (error) {
      console.error("Error fetching center data:", error);
    }
  };

  useEffect(() => {
    fetchCenter();
  }, []);

  const fetchCources = async (selectedCenter) => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centerid/${selectedCenter}`,

        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            // Add other headers if needed
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCources(data.center.courses);
      } else {
        console.error("Failed to fetch batches data");
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchCources(selectedCenter);
  }, [selectedCenter]);

  const fetchBatches = async () => {
    try {
      const decryptedToken = decryptData(sessionStorage.getItem("token"));

      // Ensure selectedCourses is not empty before making the request
      if (selectedCenter && selectedCource) {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/v1/client/center/centers/course`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${decryptedToken}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              center: {
                centerId: selectedCenter,
                courseId: selectedCource,
              },
            }),
          }
        );
        if (response.ok) {
          const data = await response.json();
          setBatches(data.center.batches);
        } else {
          console.error("Failed to fetch batches data:", response);
        }
      }
    } catch (error) {
      console.error("Error fetching batches data:", error);
    }
  };

  useEffect(() => {
    fetchBatches();
  }, [selectedCenter, selectedCource]);

  const handleCenterChange = (event) => {
    setSelectedCenter(event.target.value);
    setSelectedCource("");
    setSelectedBatch("");
    setSelectedLearner([]);
    setSelectedLearnerId([]);
  };

  const handleCourceChange = (event) => {
    setSelectedCource(event.target.value);
    setSelectedBatch("");
    setSelectedLearner([]);
    setSelectedLearnerId([]);
  };

  const handleBatchChange = (event) => {
    setSelectedBatch(event.target.value);
    setSelectedLearner([]);
    setSelectedLearnerId([]);
  };
  const handleLearnerChange = (event, value) => {
    setSelectedLearner(value.map((learner) => learner));
    setSelectedLearnerId(value.map((learner) => learner.id));
  };

  const handleSelectAllChange = () => {
    const allLearners = !selectAll ? learners : [];
    setSelectedLearner(allLearners);
    const selectedIds = allLearners.map((learner) => learner.id);
    setSelectedLearnerId(selectedIds);
    setSelectAll(!selectAll);
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/learner/all/filter/center?course_id=${selectedCource}&batch_id=${selectedBatch}&center_id=${selectedCenter}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setLearners(response.data.learners);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedCenter, selectedCource, selectedBatch, decryptedToken]);

  const handleFormSubmit = () => {
    console.log("selectedLearnerId", selectedLearnerId);
    if (!selectedCource) {
      toast.warn("Please select a course.");
      return;
    }

    const data = {
      user: {
        course_id: selectedCource,
        batch_id: selectedBatch,
        learner_ids: selectedLearnerId,
      },
    };

    axios
      .put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/examlogout/logout`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setTimeout(() => {
          navigate("/admin/dashboard");
        }, 2000);

        socket.emit("logout",{learnerIds: selectedLearnerId})

        if (selectedLearnerId.length === 0) {
          toast.success("All learner's exam logged-out successfully");
        } else {
          toast.success("Selected learner's exam logged-out successfully");
        }
      })
      .catch((error) => {
        toast.error("Failed to update Zoom Account Config");
      });
  };

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.maxh76}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Relogin Logout
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Branch <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="state"
                  value={selectedCenter}
                  onChange={handleCenterChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  {center &&
                    center.map((st) => (
                      <MenuItem key={st.id} value={st.id}>
                      {st.center_code} - {st.center_name} 
                      </MenuItem>
                    ))}
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Course <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="state"
                  value={selectedCource}
                  onChange={handleCourceChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  {cources &&
                    cources.map((st) => (
                      <MenuItem key={st.id} value={st.id}>
                        {st.course_name}
                      </MenuItem>
                    ))}
                </Select>
              </div>
            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              ></Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Batch
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="batch"
                  value={selectedBatch}
                  onChange={handleBatchChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Here</em>
                  </MenuItem>
                  {batches &&
                    batches.map((st) => (
                      <MenuItem key={st.id} value={st.id}>
                        {st.batch_name}
                      </MenuItem>
                    ))}
                </Select>
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36_6}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Learner
                </FormLabel>
                <Autocomplete
                  multiple
                  id="learner-autocomplete"
                  required
                  options={learners || []}
                  disableClearable
                  disableCloseOnSelect={true}
                  value={selectedLearner}
                  onChange={(event, newValue) => {
                    setSelectedLearner(newValue);
                    const selectedIds = newValue.map((learner) => learner.id);
                    setSelectedLearnerId(selectedIds);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectAll}
                                  onChange={handleSelectAllChange}
                                />
                              }
                              label="Select All"
                            />
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  renderOption={(option, { selected }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                      }
                      label={`${option?.full_name} - ${option?.learner_information?.roll_number}`} 
                      // label={option.full_name} // Display the full_name in the dropdown
                    />
                  )}
                  getOptionLabel={(option) => `${option.full_name} ${option?.learner_information?.roll_number}`} // Display the full_name as the selected value
                  renderTags={() => null}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  selectOnFocus
                  openOnFocus
                />
              </div>
            </div>
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className={`${classes.custombtnblue}`}
              onClick={handleFormSubmit}
            >
              Logout
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default BulkExamLogout;
